import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import type * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import { RouteParam } from '../../../../route-param'
import type { TypeParams } from '../types'

/**
 * Synchronizes the selected entity with the ZoneId route parameter.
 * Updates the current entity selection when the URL parameter or restored
 * current entity changes.
 */
export const syncCurrentEntityWithUrl = store.effects.create(
  (
    feature: ec.Collection<TypeParams>['feature'],
    zonesEc: ec.Collection<TypeParams>,
    _router: router.Router,
  ) =>
    _router.selectors.getRouteParam(RouteParam.ZoneId).asObservable.pipe(
      rxjs.combineLatestWith(
        zonesEc.plugins.currentEntityPlugin.feature.selectors.getId()
          .asObservable,
        zonesEc.plugins.editingPlugin.feature.selectors.creationsLookup
          .asObservable,
      ),
      rxjs.map(([routeId, id, creationsLookup]) => {
        const isActiveCreation =
          ec.plugins.standard.editing.models.CreationId.isCreationId(id) &&
          creationsLookup[id] !== undefined

        return id !== routeId && (routeId !== undefined || !isActiveCreation)
          ? zonesEc.plugins.currentEntityPlugin.storage.actions.putInIdLookup
              .from('syncCurrentEntityWithUrl (effect)')
              .create({
                value: routeId,
              })
          : store.effects.SKIP
      }),
    ),
)
